import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCurrentOrganizationMembers } from "@api/organizationMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const TemplateLastEditedByFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const { data: members } = useCurrentOrganizationMembers();
    const { closeTemplateUpdatedByUserIds } = filters;

    const labels = useMemo(
        () =>
            members
                ?.filter((member) =>
                    closeTemplateUpdatedByUserIds?.includes(member.user.id),
                )
                .map((member) => member.user.name) ?? [],
        [members, closeTemplateUpdatedByUserIds],
    );

    if (
        !closeTemplateUpdatedByUserIds ||
        closeTemplateUpdatedByUserIds.length === 0
    ) {
        return null;
    }

    return formatFilterLabel(labels);
};
